"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      email: "",
      error: false,
      errorMessage: null,
      isLoading: false,
      formStep: 1,
      password: "",
      confirmPassword: "",
      secretCode: "",
      validationErrors: {
        secretCode: [],
        password: [],
        confirmPassword: []
      },
      newRequestCounter: 60
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.subscribe(function (mutation) {
      if (mutation.type === "changeLocale") {
        var validationErrorsExists = false;

        for (var validationGroup in _this.validationErrors) {
          if (_this.validationErrors[validationGroup].length) {
            validationErrorsExists = true;
            break;
          }
        }

        if (validationErrorsExists) {
          _this.clearValidationErrors();
          _this.isFormValid();
        }
      }
    });
  },


  methods: {
    clearValidationErrors: function clearValidationErrors() {
      var _this2 = this;

      Object.keys(this.validationErrors).forEach(function (key) {
        return _this2.validationErrors[key] = [];
      });
    },
    setEmail: function setEmail(email) {
      this.email = email;
    },
    setPassword: function setPassword(password) {
      this.password = password;
    },
    setConfirmPassword: function setConfirmPassword(confirmPassword) {
      this.confirmPassword = confirmPassword;
    },
    setSecretCode: function setSecretCode(secretCode) {
      this.secretCode = secretCode;
    },
    sendResetPasswordRequest: function sendResetPasswordRequest() {
      var _this3 = this;

      this.isLoading = true;
      var vm = this;
      axios.post("/forgot-password", {
        email: this.email,
        locale: this.$i18n.locale
      }).then(function () {
        _this3.error = false;
        _this3.errorMessage = null;
        _this3.isLoading = false;

        _this3.formStep = 2;

        _this3.clearValidationErrors();

        setInterval(function () {
          if (vm.newRequestCounter > 0) {
            vm.newRequestCounter--;
          }
        }, 1000);
      }, function (error) {
        _this3.isLoading = false;
        _this3.handleError(error.response.data);
      }).catch(function () {
        _this3.isLoading = false;
      });
    },
    sendNewResetPasswordRequest: function sendNewResetPasswordRequest() {
      this.newRequestCounter = 60;
      this.sendResetPasswordRequest();
    },
    sendSetNewPasswordRequest: function sendSetNewPasswordRequest() {
      var _this4 = this;

      // Clear errors object.
      this.clearValidationErrors();

      if (!this.isFormValid()) {
        return;
      }

      this.isLoading = true;
      axios.post("/set-new-password", {
        email: this.email,
        secret_code: this.secretCode,
        password: this.password,
        locale: this.$i18n.locale
      }).then(function () {
        _this4.isLoading = false;

        _this4.$toastr.options.positionClass = "toast-top-center";
        _this4.$toastr.success(_this4.$t("reset_password.messages.password_is_set"));

        _this4.$emit("newPasswordIsSet");
      }, function (error) {
        _this4.isLoading = false;
        _this4.handleError(error.response.data);
      }).catch(function () {
        _this4.isLoading = false;
      });
    },
    isFormValid: function isFormValid() {
      var _this5 = this;

      if (!this.secretCode.length) {
        this.validationErrors.secretCode.push(this.$t("reset_password.validation.secret_code.empty"));
      }

      if (this.password !== this.confirmPassword) {
        this.validationErrors.confirmPassword.push(this.$t("reset_password.validation.password.not_match"));
      }

      if (this.password.length < 8) {
        this.validationErrors.password.push(this.$t("reset_password.validation.password.short"));
      }

      // Check on uppercase existence.
      if (!(this.password.toLowerCase() != this.password)) {
        this.validationErrors.password.push(this.$t("reset_password.validation.password.no_uppercase"));
      }

      // Check on lowercase existence.
      if (!(this.password.toUpperCase() != this.password)) {
        this.validationErrors.password.push(this.$t("reset_password.validation.password.no_lowercase"));
      }

      // Check on digits existence.
      if (!/\d+/.test(this.password)) {
        this.validationErrors.password.push(this.$t("reset_password.validation.password.no_digit"));
      }

      // Check non-alphabetical character existence.
      if (!/\W+/.test(this.password)) {
        this.validationErrors.password.push(this.$t("reset_password.validation.password.no_non_alphabetical"));
      }

      return Object.keys(this.validationErrors).reduce(function (accumulator, key) {
        return accumulator && !_this5.validationErrors[key].length;
      }, true);
    },
    handleError: function handleError(error) {
      this.errorMessage = _.get(error, "data.email.0", error.message);
      this.error = true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/ForgotPassword.vue
// module id = F108
// module chunks = 0 1